import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

// Resolved by Generator::SubscriptionState rather than matched against a tier list here: the
// entitlement no longer follows from studioAccessTier alone, since a migrated free trial keeps
// tier 'in_free_beta' while holding premium access for as long as its credits last.
// An active free trial is the one tier admitted on its own, mirroring the server-side
// dcc_bridge_entitled? check, so trial users can pull their generations into a DCC tool.
function useDccBridgeAccess() {
  const premiumFeatures = useThreeDStudioStore((state) => state.subscription.premiumFeatures)
  const studioAccessTier = useThreeDStudioStore((state) => state.subscription.studioAccessTier)
  return premiumFeatures === true || studioAccessTier === STUDIO_ACCESS_TIER.IN_FREE_BETA
}

export default useDccBridgeAccess
